import { cva } from 'class-variance-authority';

export const table = cva(['w-full max-h-full', 'divide-y divide-gray-200']);

export const tableBody = cva(['divide-y divide-gray-200']);
